// Share Victory: поделиться победой или кубком в чат Telegram (docs/spec/01, Социальные механики).

/** POST /api/share/prepare — сервер проверяет, что победа настоящая, и готовит сообщение. */
export type SharePrepareRequest =
  | { kind: 'cup'; tournamentId: string }
  | { kind: 'win'; matchId: string }
  /** приглашение в дуэль или кубок с друзьями */
  | { kind: 'invite'; tournamentId: string }
  /** личная реферальная ссылка «играть» */
  | { kind: 'referral' };

export interface SharePrepareResponse {
  /** id подготовленного сообщения для Telegram.WebApp.shareMessage */
  preparedMessageId: string;
  /** ссылка «играть» и текст — для запасного шеринга через t.me/share/url */
  link: string;
  text: string;
}

/** Параметр запуска «сразу в турнир»; после «_r» — код пригласившего (id в base36). */
export const PLAY_START_PARAM = 'play';
export const playStartParam = (inviterId?: number) =>
  inviterId ? `${PLAY_START_PARAM}_r${inviterId.toString(36)}` : PLAY_START_PARAM;
export const isPlayStartParam = (p: string | null | undefined) =>
  !!p && (p === PLAY_START_PARAM || p.startsWith(`${PLAY_START_PARAM}_`));
/** id пригласившего из параметра запуска (или null). */
export function inviterFrom(p: string | null | undefined): number | null {
  const m = /^play_r([0-9a-z]{1,10})$/.exec(p ?? '');
  const id = m ? parseInt(m[1]!, 36) : NaN;
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

/** Приглашение в дружеский турнир из параметра запуска: duel_<код> или cup_<код>. */
export function inviteFromStartParam(
  p: string | null | undefined,
): { kind: 'DUEL' | 'FRIENDS'; code: string } | null {
  const m = /^(duel|cup)_([a-z2-9]{8})$/.exec(p ?? '');
  return m ? { kind: m[1] === 'duel' ? 'DUEL' : 'FRIENDS', code: m[2]! } : null;
}

export const inviteStartParam = (kind: 'DUEL' | 'FRIENDS', code: string) =>
  `${kind === 'DUEL' ? 'duel' : 'cup'}_${code}`;

/** Размеры кубка с друзьями */
export const FRIENDS_CUP_SIZES = [4, 8] as const;
